export default "__VITE_ASSET__DyHbm3si__"